import { Card, CardContent } from "@/components/ui/card";
import { formatRewardAmount } from "@/lib/textUtils";

interface RewardsCardProps {
  title: string;
  value: string | number;
  icon: string; // SVG file path
  variant?: "default" | "dark";
  testId?: string;
}

export function RewardsCard({ 
  title, 
  value, 
  icon, 
  variant = "default",
  testId 
}: RewardsCardProps) {
  const isDark = variant === "dark";
  
  return (
    <Card 
      className={`border-0 shadow-sm ${isDark ? "text-white" : ""}`}
      style={isDark ? { backgroundColor: '#2D2D2D' } : {}}
      data-testid={testId}
    >
      <CardContent 
        className="p-0"
        style={{
          display: 'flex',
          padding: '16px',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '8px'
        }}
      >
        <img 
          src={icon} 
          alt={title}
          className="h-6 w-6 sm:h-7 sm:w-7"
        />
        <p className={`text-2xl sm:text-3xl font-bold space-grotesk ${
          isDark ? "text-white" : "text-gray-900"
        }`}>
          {typeof value === 'number' ? `R${formatRewardAmount(value)}` : value}
        </p>
        <p className={`text-xs font-medium uppercase space-grotesk leading-tight tracking-[0.07px] ${
          isDark ? "text-gray-400" : "text-gray-500"
        }`}>
          {title}
        </p>
      </CardContent>
    </Card>
  );
}
